export default __webpack_public_path__ + "media/Nutrition.59fe4fe7.svg";